<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      margin="5"
      filename="inventory-report.pdf"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-content-width="100%"
      :paginate-elements-by-height="2340"
      @beforeDownload="beforeDownload"
      ref="html2Pdf"
    >
      <div slot="pdf-content" class="pdf-content">

        <!-- Header Banner -->
        <div class="header-banner">
          <div class="header-title">INVENTORY REPORT</div>
          <div class="header-subtitle">{{ data.unit_name }}{{ data.address ? ` — ${data.address}` : '' }}{{ data.unit ? ` (Unit ${data.unit})` : '' }}{{ data.floor ? `, Floor ${data.floor}` : '' }}{{ data.building ? `, Tower ${data.building}` : '' }}</div>
        </div>

        <!-- Property Info Cards -->
        <div class="info-grid">
          <div class="info-card">
            <div class="info-row">
              <span class="info-label">Residence</span>
              <span class="info-value">{{ data.unit_name }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Unit No.</span>
              <span class="info-value">{{ data.address }}{{ data.unit ? ` (Unit ${data.unit})` : '' }}{{ data.building ? `, Tower ${data.building}` : '' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Floor</span>
              <span class="info-value">{{ data.floor }}</span>
            </div>
          </div>
          <div class="info-card">
            <div class="info-row">
              <span class="info-label">Date of Record</span>
              <span class="info-value">{{ data.date_record }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Lease Start</span>
              <span class="info-value">{{ data.lease_start }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Lease Expire</span>
              <span class="info-value">{{ data.lease_expire }}</span>
            </div>
          </div>
        </div>

        <!-- Key Hand Over -->
        <div class="table-container" v-for="(item, index) in queryData" :key="index">
          <div v-if="item.title == 'KEY HAND OVER'">
            <div class="section-title">{{ item.title }}</div>
            <table class="table-pdf">
              <thead>
                <tr>
                  <th class="th-pdf width-keyhand">Item</th>
                  <th class="th-pdf width-photo-handover">Photo</th>
                  <th class="th-pdf width-quantity">Qty</th>
                  <th class="th-pdf width-description">Description</th>
                  <th class="th-pdf width-arrival-keyhand">Arrival</th>
                  <th class="th-pdf width-departure-keyhand">Departure</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(furniture, index) in item.furnitures" :key="index" :class="index % 2 === 1 ? 'row-stripe' : ''">
                  <td class="td-pdf td-left">{{ furniture.title.join(", ") }}</td>
                  <td v-if="index === 0" :rowspan="item.furnitures.length" class="td-pdf td-center">
                    <img :src="imageKeyHand" alt="Key Photo" class="img-handover" />
                  </td>
                  <td class="td-pdf td-center">{{ item.furnitures[index].quantity }}</td>
                  <td class="td-pdf td-left">{{ item.furnitures[index].description }}</td>
                  <td class="td-pdf td-center"></td>
                  <td class="td-pdf td-center"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Electricity Meter -->
        <div class="table-container">
          <div class="section-title">Electricity Meter</div>
          <table class="table-pdf">
            <thead>
              <tr>
                <th class="th-pdf width-meter">Item</th>
                <th class="th-pdf width-photo-handover">Photo</th>
                <th class="th-pdf width-description-meter">Reading</th>
                <th class="th-pdf width-arrival">Arrival</th>
                <th class="th-pdf width-departure">Departure</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="td-pdf td-left">On Arrival</td>
                <td class="td-pdf td-center">
                  <img v-if="electricity_arrival_image" :src="electricity_arrival_image" alt="Meter Photo" class="photo-meter"/>
                </td>
                <td class="td-pdf td-center">{{ data.electricity_arrival }}</td>
                <td class="td-pdf td-center"></td>
                <td class="td-pdf td-center"></td>
              </tr>
              <tr class="row-stripe">
                <td class="td-pdf td-left">On Departure</td>
                <td class="td-pdf td-center">
                  <img v-if="electricity_departure_image" :src="electricity_departure_image" alt="Meter Photo" class="photo-meter"/>
                </td>
                <td class="td-pdf td-center">{{ data.electricity_departure }}</td>
                <td class="td-pdf td-center"></td>
                <td class="td-pdf td-center"></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Water Meter -->
        <div class="table-container">
          <div class="section-title">Water Meter</div>
          <table class="table-pdf">
            <thead>
              <tr>
                <th class="th-pdf width-meter">Item</th>
                <th class="th-pdf width-photo-handover">Photo</th>
                <th class="th-pdf width-description-meter">Reading</th>
                <th class="th-pdf width-arrival">Arrival</th>
                <th class="th-pdf width-departure">Departure</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="td-pdf td-left">On Arrival</td>
                <td class="td-pdf td-center">
                  <img v-if="water_arrival_image" :src="water_arrival_image" alt="Meter Photo" class="photo-meter"/>
                </td>
                <td class="td-pdf td-center">{{ data.water_arrival }}</td>
                <td class="td-pdf td-center"></td>
                <td class="td-pdf td-center"></td>
              </tr>
              <tr class="row-stripe">
                <td class="td-pdf td-left">On Departure</td>
                <td class="td-pdf td-center">
                  <img v-if="water_departure_image" :src="water_departure_image" alt="Meter Photo" class="photo-meter"/>
                </td>
                <td class="td-pdf td-center">{{ data.water_departure }}</td>
                <td class="td-pdf td-center"></td>
                <td class="td-pdf td-center"></td>
              </tr>
            </tbody>
          </table>
          <div class="note-box">
            <strong>Note:</strong> Tenant is responsible for their own electricity and water supply bills.
          </div>
        </div>

        <div class="page-break"></div>

        <!-- Room Sections -->
        <div class="table-container" v-for="(item, index) in data.data" :key="index">
          <div v-if="item.title != 'KEY HAND OVER'">

            <div class="room-title">
              <span class="room-label">Room / Area:</span> {{ item.title }}
            </div>

            <table class="table-pdf" v-if="item.furnitures.length">
              <thead>
                <tr>
                  <th class="th-pdf width-item">Item</th>
                  <th class="th-pdf width-photo">Photo</th>
                  <th class="th-pdf width-quantity">Qty</th>
                  <th class="th-pdf width-description">Description</th>
                  <th class="th-pdf width-arrival">Arrival</th>
                  <th class="th-pdf width-departure">Departure</th>
                </tr>
              </thead>
              <tbody v-for="(furniture, index) in item.furnitures" :key="index">
                <tr :class="index % 2 === 1 ? 'row-stripe' : ''">
                  <td class="td-pdf td-left">
                    <span v-if="furniture" v-html="furniture.title.join('<br>')"></span>
                  </td>
                  <td class="td-pdf td-center">
                    <div v-for="(image, index) in item.furnitures[index].images" :key="index" class="image-container">
                      <img v-if="image" :src="getSrcFromLists(image)" alt="Photo" class="photo-img" />
                    </div>
                  </td>
                  <td class="td-pdf td-center">{{ item.furnitures[index].quantity }}</td>
                  <td class="td-pdf td-left">{{ item.furnitures[index].description }}</td>
                  <td class="td-pdf td-center"></td>
                  <td class="td-pdf td-center"></td>
                </tr>
              </tbody>
            </table>

            <div v-if="item.defects.length">
              <div class="defect-title">Defect Report</div>
              <table class="table-pdf">
                <thead class="defect-header">
                  <tr>
                    <th class="th-pdf width-item">Item</th>
                    <th class="th-pdf width-photo">Photo</th>
                    <th class="th-pdf width-quantity">Qty</th>
                    <th class="th-pdf width-description">Description</th>
                    <th class="th-pdf width-arrival">Arrival</th>
                    <th class="th-pdf width-departure">Departure</th>
                  </tr>
                </thead>
                <tbody v-for="(defect, index) in item.defects" :key="index">
                  <tr :class="index % 2 === 1 ? 'row-stripe-defect' : ''">
                    <td class="td-pdf td-left">
                      <span v-if="defect" v-html="defect.title.join('<br>')"></span>
                    </td>
                    <td class="td-pdf td-center">
                      <div v-for="(image, index) in item.defects[index].images" :key="index" class="image-container">
                        <img v-if="image" :src="getSrcDefectsFromLists(image)" alt="Photo" class="photo-img" />
                      </div>
                    </td>
                    <td class="td-pdf td-center">{{ item.defects[index].quantity }}</td>
                    <td class="td-pdf td-left">{{ item.defects[index].description }}</td>
                    <td class="td-pdf td-center"></td>
                    <td class="td-pdf td-center"></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

        <!-- Disclaimer -->
        <div class="disclaimer-box">
          <p>This inventory form is for your protection. It helps establish the condition of your apartment at the time of your arrival, and should be completed and returned to your landlord within the first three days of occupancy. Be specific and check carefully when completing this form.</p>
          <p>Look for dust, grease, stains, burns, damages, and wear and tear. Cross out items that do not apply and use additional paper if more space is needed.</p>
          <p><strong>NOTE:</strong> Copies of the entire inventory, including any attachments, should be provided to both lessor and lessee.</p>
        </div>

        <!-- Signatures -->
        <div class="signature-section">
          <div class="signature-box">
            <div class="sig-role">LESSOR</div>
            <div class="sig-name">{{ data.lessor }}</div>
            <div class="sig-line-wrap">
              <div class="sig-field"><span class="sig-field-label">Signature</span><div class="sig-line"></div></div>
              <div class="sig-field"><span class="sig-field-label">Name</span><div class="sig-line"></div></div>
              <div class="sig-field"><span class="sig-field-label">Date</span><div class="sig-line"></div></div>
            </div>
          </div>
          <div class="signature-box">
            <div class="sig-role">LESSEE</div>
            <div class="sig-name">{{ data.lessee }}</div>
            <div class="sig-line-wrap">
              <div class="sig-field"><span class="sig-field-label">Signature</span><div class="sig-line"></div></div>
              <div class="sig-field"><span class="sig-field-label">Name</span><div class="sig-line"></div></div>
              <div class="sig-field"><span class="sig-field-label">Date</span><div class="sig-line"></div></div>
            </div>
          </div>
        </div>

      </div>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import router from '@/router'
import axios from '@axios'

export default {
  components: {
    VueHtml2pdf,
  },
  props: {
  },
  data() {
    return {
      queryData : [],
      data : {},
      imageLists : [],
      imageDefectLists : [],
      imageKeyHand: '',
      src: '',
      electricity_arrival_image: null,
      electricity_departure_image: null,
      water_arrival_image: null,
      water_departure_image: null,
      inventoryPrintData: {}
    };
  },
  methods: {
    getSrcFromLists (url) {
      return this.imageLists.find(v => v.url === url)?.src ?? ''
    },
    getSrcDefectsFromLists (url) {
      return this.imageDefectLists.find(v => v.url === url)?.src ?? ''
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      try {
        options = options || {};

        if (!Array.isArray(options.margin)) {
          options.margin = [0.7, 0.1, 0.7, 0.1];
        }

        await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .get('pdf')
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages()
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i)
              pdf.setFontSize(9)
              pdf.setTextColor(150)
              pdf.text(
                `Page ${i} of ${totalPages}`,
                pdf.internal.pageSize.getWidth() / 2,
                pdf.internal.pageSize.getHeight() - 5,
                { align: 'center' }
              )
            }
          })
          .output('bloburl')
          .then((r) => {
            window.open(r);
          });
      } catch (error) {
        console.error('Error in beforeDownload:', error);
      }
    },
    async generatePdf() {
      this.$refs.html2Pdf.generatePdf();

      setTimeout(() => {
        window.close();
      }, 1000)
    },
    async getImageSrc(imageUrl) {
        if(imageUrl == null) return ''
        const fileName = imageUrl.replace("https://digitalnation.sgp1.digitaloceanspaces.com/findbangkokroom/inventory-list/", "");

        const data = {
          filename: fileName,
          folder: 'inventory-list',
        };
        
        let res = await axios.post('/copy/v1/download-s3', data);
        const base64String = `data:${res.data.ContentType};base64,${res.data.base64String}`;
        return base64String;
    },
     jsonParseSafe(data) {
      try {
        return JSON.parse(data)
      } catch (err) {
        return null
      }
    },
  },
  async mounted() {

    const { data } = await axios.post(`/property/v1/listsprint/get/${router.currentRoute.query.inventory_id}`)

    const queryData = data

    if (queryData) {
      this.queryData = queryData?.data?.data ?? []
      this.data = queryData.data ?? {}
    }

    const furnitureImagePromises = this.queryData.flatMap(item =>
      Array.isArray(item.furnitures)
        ? item.furnitures.flatMap(f =>
            (f.images ?? []).map(async image => ({ url: image ?? '', src: await this.getImageSrc(image) }))
          )
        : []
    )

    const defectImagePromises = this.queryData.flatMap(item =>
      Array.isArray(item.defects)
        ? item.defects.flatMap(d =>
            (d.images ?? []).map(async image => ({ url: image ?? '', src: await this.getImageSrc(image) }))
          )
        : []
    )

    ;[this.imageLists, this.imageDefectLists] = await Promise.all([
      Promise.all(furnitureImagePromises),
      Promise.all(defectImagePromises),
    ])

    this.electricity_arrival_image = this.data?.electricity_arrival_image != ''? await this.getImageSrc(this.data?.electricity_arrival_image): ''
    this.electricity_departure_image = this.data?.electricity_departure_image != ''? await this.getImageSrc(this.data?.electricity_departure_image): ''
    this.water_arrival_image = this.data?.water_arrival_image != ''?await this.getImageSrc(this.data?.water_arrival_image): ''
    this.water_departure_image = this.data?.water_departure_image != ''? await this.getImageSrc(this.data?.water_departure_image): ''
    this.imageKeyHand = await this.getImageSrc(this.queryData[0]?.image)
    
    this.generatePdf();
  },
}
</script>

<style>
/* ── Base ── */
body, .pdf-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 12px;
  color: #212529;
  line-height: 1.5;
  margin: 0;
  padding: 0;
}

/* ── Header Banner ── */
.header-banner {
  background-color: #1e3a5f;
  color: #ffffff;
  padding: 14px 16px 10px;
  margin-bottom: 12px;
}
.header-title {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1.5px;
}
.header-subtitle {
  font-size: 10px;
  margin-top: 4px;
  color: #b8cfe8;
}

/* ── Info Cards ── */
.info-grid {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}
.info-card {
  flex: 1;
  background-color: #f5f7fa;
  border: 1px solid #d0d7de;
  border-radius: 4px;
  padding: 8px 12px;
}
.info-row {
  display: flex;
  padding: 3px 0;
  border-bottom: 1px solid #e4e7eb;
}
.info-row:last-child {
  border-bottom: none;
}
.info-label {
  color: #6b7280;
  width: 95px;
  flex-shrink: 0;
  font-size: 10px;
}
.info-value {
  color: #1a1a2e;
  font-weight: 600;
  font-size: 10px;
}

/* ── Section Titles ── */
.section-title {
  background-color: #1e3a5f;
  color: #ffffff;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.5px;
  padding: 5px 10px;
  margin-top: 14px;
  margin-bottom: 0;
}
.room-title {
  background-color: #e8eef5;
  border-left: 4px solid #1e3a5f;
  padding: 5px 10px;
  margin-top: 14px;
  font-size: 11px;
  font-weight: bold;
  color: #1e3a5f;
}
.room-label {
  color: #6b7280;
  font-weight: normal;
}
.defect-title {
  background-color: #fef2f2;
  border-left: 4px solid #c0392b;
  padding: 5px 10px;
  margin-top: 10px;
  font-size: 11px;
  font-weight: bold;
  color: #c0392b;
}

/* ── Tables ── */
.table-container {
  margin-bottom: 6px;
}
.table-pdf {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;
}
.th-pdf {
  background-color: #2d5a8e;
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  padding: 6px 5px;
  border: 1px solid #1e3a5f;
}
.td-pdf {
  border: 1px solid #d0d7de;
  font-size: 10px;
  padding: 5px 6px;
  vertical-align: middle;
}
.td-left  { text-align: left; }
.td-center { text-align: center; }

/* Zebra stripes */
.row-stripe { background-color: #f0f4f8; }
.row-stripe-defect { background-color: #fff5f5; }

/* Defect header */
.defect-header th {
  background-color: #c0392b;
  border-color: #922b21;
}

/* ── Images ── */
.photo-img {
  width: 100%;
  max-height: 90px;
  object-fit: cover;
  padding: 2px;
}
.photo-meter {
  width: 100%;
  max-height: 80px;
  object-fit: cover;
  padding: 2px;
}
.img-handover {
  width: 100%;
  max-height: 100px;
  object-fit: cover;
  padding: 2px;
}
.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  page-break-inside: avoid;
}

/* ── Note box ── */
.note-box {
  background-color: #fffbeb;
  border-left: 4px solid #f59e0b;
  padding: 6px 10px;
  margin-top: 6px;
  font-size: 10px;
  color: #78350f;
}

/* ── Disclaimer ── */
.disclaimer-box {
  background-color: #f5f7fa;
  border: 1px solid #d0d7de;
  border-left: 4px solid #2d5a8e;
  padding: 10px 12px;
  margin-top: 20px;
  font-size: 10px;
  color: #374151;
  line-height: 1.6;
}
.disclaimer-box p {
  margin: 0 0 6px;
}
.disclaimer-box p:last-child {
  margin-bottom: 0;
}

/* ── Signatures ── */
.signature-section {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 30px;
}
.signature-box {
  flex: 1;
  border: 1px solid #d0d7de;
  border-top: 3px solid #1e3a5f;
  padding: 12px;
  background-color: #f9fafb;
}
.sig-role {
  font-size: 12px;
  font-weight: bold;
  color: #1e3a5f;
  letter-spacing: 1px;
}
.sig-name {
  font-size: 10px;
  color: #6b7280;
  margin: 2px 0 12px;
}
.sig-line-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sig-field {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sig-field-label {
  font-size: 9px;
  color: #6b7280;
  width: 55px;
  flex-shrink: 0;
}
.sig-line {
  flex: 1;
  border-bottom: 1px solid #9ca3af;
}

/* ── Column widths ── */
.width-item            { width: 16%; }
.width-photo           { width: 24%; }
.width-quantity        { width: 5%;  }
.width-arrival         { width: 10%; }
.width-arrival-keyhand { width: 9%;  }
.width-departure       { width: 10%; }
.width-departure-keyhand { width: 9%; }
.width-keyhand         { width: 18%; }
.width-photo-handover  { width: 24%; }
.width-meter           { width: 20%; }
.width-description     { width: 20%; }
.width-description-meter { width: 30%; }

/* ── Page break ── */
.page-break {
  page-break-before: always;
  break-before: page;
  height: 0;
}
@media print {
  .page-break { page-break-before: always; }
  table       { page-break-inside: auto; }
  tr          { page-break-inside: avoid; page-break-after: auto; }
  img         { page-break-inside: avoid; }
}
</style>
